const {
  lendingClubPalette,
  mobilePalette,
} = require('./brandPalette/brandPalette');

module.exports = {
  lendingClubPalette,
  mobilePalette,
};

